import JQueryView, { on } from '../../../../common/views/jqueryView';

export default class FormView extends JQueryView {
  others: boolean;

  constructor(others: boolean) {
    super('.simple_form');
    this.others = others;

    // 初期表示 クラスふよ
    $('input:visible ,select:visible ,textarea:visible').each(function () {
      const $el = $(this);
      // エラーではない、かつ入力ありならば is-activatedつける
      if (!$el.hasClass('is-invalid') && $el.val() !== '') {
        $el.addClass('is-activated');
      }
    });
    this.render();
  }

  @on({ event: 'change', selector: '#white_paper_user_role' })
  onChangeOther() {
    var roleType = $('#white_paper_user_role').val();
    if (roleType == 'other') {
      this.others = true;
      this.render();
    } else {
      this.others = false;
      this.render();
    }
  }

  @on({ event: 'change', selector: 'input, select, textarea' })
  onChangeInputStyle(e: JQuery.ChangeEvent) {
    const $el = $(e.currentTarget);
    if ($el.val() === '') {
      $el.removeClass('is-activated');
    } else {
      $el.addClass('is-activated').removeClass('is-invalid');

      $el.parents('.download-page-block').find('.invalid-feedback').hide();
    }
  }

  @on({ event: 'change', selector: '.js-download-input' })
  onChangeHideError(e: JQuery.ChangeEvent) {
    $(e.currentTarget)
      .parents('.download-check')
      .find('.invalid-feedback')
      .hide();
  }

  @on({ event: 'change', selector: '.js-file-input' })
  onChangeFileInput(e: JQuery.ChangeEvent) {
    const $input = $(e.currentTarget);
    const files = ($input[0] as HTMLInputElement).files;
    const $wrapper = $input.closest('.js-file-input-wrapper');
    const $fileNameDisplay = $wrapper.find('.js-file-name-display');
    const $removeBtn = $wrapper.find('.js-file-remove-btn');

    if (files && files.length > 0) {
      $fileNameDisplay.text(files[0].name);
      $removeBtn.show();
    } else {
      $fileNameDisplay.text('');
      $removeBtn.hide();
    }
  }

  @on({ event: 'click', selector: '.js-file-remove-btn' })
  onClickRemoveFile(e: JQuery.ClickEvent) {
    const $btn = $(e.currentTarget);
    const $wrapper = $btn.closest('.js-file-input-wrapper');
    const $input = $wrapper.find('.js-file-input');
    const $fileNameDisplay = $wrapper.find('.js-file-name-display');

    // ファイル入力をクリア
    ($input[0] as HTMLInputElement).value = '';
    $fileNameDisplay.text('');
    $btn.hide();
  }

  render() {
    if (this.others) {
      $('#white_paper_user_other_role').show();
    } else {
      $('#white_paper_user_other_role').hide();
    }
  }
}
